<template>
  <div v-if="visible" class="sfjc-overlay" @click.self="onCancel">
    <div class="sfjc-dialog">
      <div class="sfjc-title">
        <span>是否拒测设定</span>
        <span class="sfjc-close" @click="onCancel">×</span>
      </div>
      <div class="sfjc-body">
        <div class="sfjc-row">
          <label class="sfjc-label">是否拒测：</label>
          <el-radio-group v-model="form.SFJC">
            <el-radio value="否">否</el-radio>
            <el-radio value="是">是</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="sfjc-footer">
        <button type="button" class="sfjc-btn" @click="onCancel">取消</button>
        <button type="button" class="sfjc-btn sfjc-btn-primary" @click="onConfirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SfjcSetDialog',
  props: {
    visible: { //是否显示
      type: Boolean,
      default: false,
    },
    value: { //当前值（否/是）
      type: String,
      default: '否',
    },
  },
  data() {
    return {
      form: {
        SFJC: '否',
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() { //用当前值初始化表单
      this.form = {
        SFJC: this.value === '是' ? '是' : '否',
      };
    },
    onCancel() {
      this.$emit('close');
    },
    onConfirm() {
      this.$emit('confirm', {
        SFJC: this.form.SFJC,
      });
    },
  },
};
</script>

<style scoped>
.sfjc-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sfjc-dialog {
  width: 320px;
  background-color: #f0f0f0;
  border: 1px solid #999;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  text-align: left;
}

.sfjc-title {
  background-color: #e0e0e0;
  padding: 6px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}

.sfjc-close {
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.sfjc-body {
  padding: 12px 10px;
}

.sfjc-row {
  display: flex;
  align-items: center;
}

.sfjc-label {
  width: 90px;
  line-height: 24px;
  flex-shrink: 0;
}

.sfjc-footer {
  padding: 8px 10px;
  text-align: right;
  border-top: 1px solid #d0d0d0;
}

.sfjc-btn {
  margin-left: 8px;
  padding: 2px 14px;
  cursor: pointer;
}

.sfjc-btn-primary {
  background-color: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
</style>
